<template>
<el-main class="el-main-payment">
    <div id="app">
        <h4>Your credit card will not be charged until the end of your free trial period.</h4>
        <h4>If you would like to cancel your subscription before the trial ends please contact
            <a href="mailto:info@berst.io">info@berst.io</a></h4>
        <el-form ref="form" :rules="rules" :model="form">
            <el-form-item prop="planType">
                <el-radio-group v-model="form.planType">
                    <el-radio label="Monthly Plan"></el-radio>
                    <el-radio label="Yearly Plan"></el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
            <el-col :span="18">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="payment-header">Payment</span>
                    </div>
                    <el-form label-position="top" label-width="100px">
                        <el-row :gutter="1" class="text-align-left">
                            <el-col :span="18">
                                <label>Card Number</label>
                                <el-form-item>
                                    <card-number class="stripe-element card-number" ref="cardNumber" :stripe="stripe" :options="options" @change="number = $event.complete" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <label>CVC</label>
                                <el-form-item>
                                    <card-cvc class="stripe-element card-cvc" ref="cardCvc" :stripe="stripe" :options="options" @change="cvc = $event.complete" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="text-align-left">
                            <el-col>
                                <label>Card expiry</label>
                                <el-form-item class="text-align-left">
                                    <card-expiry class="stripe-element card-expiry" ref="cardExpiry" :stripe="stripe" :options="options" @change="expiry = $event.complete" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <el-row type="flex" justify="center" style="margin-top:30px;">
            <el-col :span="6">
                <el-button type="primary" class="pay-with-stripe" @click="pay">
                    Add payment method
                </el-button>
                <img src="../public/Stripe_Berst-Powered-by-Stripe-Logo.wine.png" alt="powered by stripe" style="height: 100px">
            </el-col>
        </el-row>
    </div>
</el-main>
</template>

<script>
import {
    createToken,
    CardNumber,
    CardExpiry,
    CardCvc
} from 'vue-stripe-elements-plus';

export default {
    name: 'Payment',
    props: ['addPaymentDetails'],
    data() {
        return {
            stripe: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
            complete: false,
            number: false,
            expiry: false,
            cvc: false,
            options: {},
            form: {
                planType: 'Monthly Plan'
            },
            rules: {
                planType: [{
                    required: true,
                    message: 'Please check on of the value',
                    trigger: ['change', 'blur']
                }],
            }
        };
    },
    components: {
        CardNumber,
        CardExpiry,
        CardCvc
    },
    methods: {
        update() {
            this.complete = this.number && this.expiry && this.cvc;
            if (this.number) {
                if (!this.expiry) {
                    this.$refs.cardExpiry.focus();
                } else if (!this.cvc) {
                    this.$refs.cardCvc.focus();
                }
            } else if (this.expiry) {
                if (!this.cvc) {
                    this.$refs.cardCvc.focus();
                } else if (!this.number) {
                    this.$refs.cardNumber.focus();
                }
            }
        },
        pay() {
            createToken().then(async data => {
                this.addPaymentDetails(data, this.form.planType);
            });
        }
    },
    watch: {
        number() {
            this.update();
        },
        expiry() {
            this.update();
        },
        cvc() {
            this.update();
        }
    }
};
</script>

<style scoped>
h4 {
    text-align: left;
}

.el-main.el-main-payment {
    margin: 0 auto !important;
    max-width: 600px;
    overflow: hidden;
}

.payment-header {
    font-size: 20px;
    font-weight: 600;
}

.text-align-left {
    text-align: left;
}
</style>
